export default {
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getSearchFields: state => state.searchFields,
    getFormActions: state => state.formActions,
    getRowActions: state => state.rowActions,
    getHeaderFields: state => state.headerFields,

    getPatientRowActions: state => state.patientRowActions,
    getPatientHeaderFields: state => state.patientHeaderFields,
    getPatientSearchFields: state => state.patientSearchFields,
    getPatientDisplayedFields: state => state.patientDisplayedFields,
    getPatientFormActions: state => state.patientFormActions,
    getPatientDataTableOptions: state => state.patientDataTableOptions,
    getPatientActions: state => state.patientActions,
    getCopyHeaderFields: state => state.copyHeaderFields,
    getContactActions: state => state.contactActions,
}
